import { gql } from '@apollo/client';

export const CREATE_CHANNEL_MONETIZATION_PROGRAM = gql`
  mutation CreateChannelMonetizationProgram(
    $input: CreateChannelMonetizationProgramInput!
  ) {
    createChannelMonetizationProgram(input: $input) {
      id
      monthLabel
      prizeAmount
      prizeCurrency
      slotsPerMonth
      status
    }
  }
`;

export const UPDATE_CHANNEL_MONETIZATION_PROGRAM = gql`
  mutation UpdateChannelMonetizationProgram(
    $input: UpdateChannelMonetizationProgramInput!
  ) {
    updateChannelMonetizationProgram(input: $input) {
      id
      monthLabel
      prizeAmount
      prizeCurrency
      slotsPerMonth
      status
    }
  }
`;

export const SET_CHANNEL_MONETIZATION_MILESTONE_TARGETS = gql`
  mutation SetChannelMonetizationMilestoneTargets(
    $input: SetChannelMonetizationMilestoneTargetsInput!
  ) {
    setChannelMonetizationMilestoneTargets(input: $input) {
      id
      programId
      type
      target
      enabled
      displayOrder
    }
  }
`;

export const BACKFILL_CHANNEL_MONETIZATION_CURRENT_MONTH = gql`
  mutation BackfillChannelMonetizationCurrentMonth {
    backfillChannelMonetizationCurrentMonth {
      processed
      rebuilt
    }
  }
`;

export const REVIEW_CHANNEL_MONETIZATION_APPLICATION = gql`
  mutation ReviewChannelMonetizationApplication(
    $input: ReviewChannelMonetizationApplicationInput!
  ) {
    reviewChannelMonetizationApplication(input: $input) {
      id
      status
      reviewedAt
      reviewerId
      rejectionReason
    }
  }
`;
